export default __webpack_public_path__ + "static/media/banner5.860c3138.svg";